"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _disabledMixin = require("../disabledMixin");
var _focusMixin = require("../focusMixin");
var _radioStateMixin = require("../radioStateMixin");
var _spacingMixin = require("../spacingMixin");
var offscreenCSS = function offscreenCSS(_ref) {
  var offscreen = _ref.offscreen;
  if (!offscreen) {
    return '';
  }
  return "\n      && {\n          position: absolute;\n          left: -99999px;\n      }\n  ";
};
var zsgCSS = (0, _styledToken.default)({
  fontColorLabel: 'colors.textDark',
  size: 'Radio.size'
}, function (_ref2) {
  var fontColorLabel = _ref2.fontColorLabel,
    size = _ref2.size;
  return (0, _styledComponents.css)(["input&{position:static;height:", "px;width:", "px;}input& + label{padding-left:0;&:hover{color:", ";}}input& + label:before,input&:checked + label:after{content:none;}"], size, size, fontColorLabel);
});

/** @class RadioMixin */
/** @method */
var RadioMixin = function RadioMixin(props) {
  return (0, _styledComponents.css)(["", " ", " &:hover:not(:disabled){", "}&:active:not(:disabled){", "}&:checked{", "}&:disabled{", "}", " ", " ", ""], zsgCSS(props), (0, _radioStateMixin.radioStateMixin)()(props), (0, _radioStateMixin.radioStateMixin)('hover')(props), (0, _radioStateMixin.radioStateMixin)('pressed')(props), (0, _radioStateMixin.radioStateMixin)('checked')(props), (0, _disabledMixin.disabledMixin)(Object.assign({}, props, {
    disabled: true
  })), (0, _focusMixin.focusMixin)(props), offscreenCSS(props), (0, _spacingMixin.spacingMixin)(props));
};
exports.RadioMixin = RadioMixin;